<script setup>
import VirtualCard from './cards/VirtualCard.vue';
import OnDemandCard from './cards/OnDemandCard.vue';
import InPersonCard from './cards/InPersonCard.vue';
import InPersonAndVirtualCard from './cards/InPersonAndVirtualCard.vue';

defineProps({
  events: {
    type: Array,
    default: () => [],
  },
});

const getImg = (event) => ({
  ...event.assetForWaitingRoom,
  alt: event.assetAltTextWaitingRoom,
});
</script>
<template>
  <div
    class="
      content-wrapper
      grid grid-cols-1
      gap-4
      pt-4
      pb-12
      desktop:grid-cols-2 desktop:gap-9 desktop:py-7
    "
  >
    <template v-for="event in events" :key="event.id">
      <VirtualCard
        v-if="event.typeEvent.name === 'VIRTUAL'"
        v-bind="event"
        :img="getImg(event)"
      />
      <OnDemandCard
        v-if="event.typeEvent.name === 'ON-DEMAND'"
        v-bind="event"
        :img="getImg(event)"
      />
      <InPersonCard
        v-if="event.typeEvent.name === 'IN-PERSON'"
        v-bind="event"
        :img="getImg(event)"
      />
      <InPersonAndVirtualCard
        v-if="event.typeEvent.name === 'IN-PERSON/VIRTUAL'"
        v-bind="event"
        :img="getImg(event)"
      />
    </template>
  </div>
</template>
